import { createApp } from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './styles/ElementPlus.scss'
import './styles/Basic.scss'
//import 'element-plus/dist/index.css'
import './styles/Tabulator.scss'
//import "tabulator-tables/dist/css/tabulator_midnight.min.css";
import ElementPlus from 'element-plus'
import App from './App.vue'
import route from './utils/route';
import store from './utils/store';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App).use(route);

app.use(VueAxios, axios)
app.use(store)
app.use(ElementPlus)


for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.mount('#app')